import { observer } from 'mobx-react';

import { TaskAttributes } from 'chaika-test-attributes';

import { translate } from '@chaika/i18n/helper';

import { TaskSection } from '../TaskSection';
import { TaskInputSubstitutor } from '../TaskInputSubstitutor';
import { TaskTypeSelect } from './TaskTypeSelect';
import { DescriptionTextInput } from '../DescriptionTextInput';

import { useTaskDescription } from './hooks/useTaskDescription';

interface Props {
    isTypeShownInHeader?: boolean;
}

export const TaskDescription = observer(({ isTypeShownInHeader = false }: Props): React.ReactElement<any> => {
    const { canEdit, typeOptions, typeData, description, onSelect, onChange } = useTaskDescription();

    const [typeId, typeName] = typeData;
    const isTypeHidden = isTypeShownInHeader && !canEdit;

    return (
        <TaskSection title={isTypeHidden ? undefined : translate('task')}>
            {!isTypeHidden && (
                <TaskInputSubstitutor
                    canEdit={canEdit}
                    label={!canEdit ? '' : translate('whatNeedsToBeDone')}
                    value={typeName}
                    dataTest={TaskAttributes.Type}
                >
                    <TaskTypeSelect
                        options={typeOptions}
                        typeId={typeId}
                        onSelect={onSelect}
                        dataTest={TaskAttributes.Type}
                    />
                </TaskInputSubstitutor>
            )}
            <TaskInputSubstitutor
                canEdit={canEdit}
                label={translate('comment')}
                value={description}
                dataTest={TaskAttributes.ToDo}
            >
                <DescriptionTextInput
                    minRows={1}
                    placeholder={translate('taskDescription')}
                    title={translate('comment')}
                    value={description}
                    name={'description'}
                    dataTest={TaskAttributes.ToDo}
                    onChange={onChange}
                />
            </TaskInputSubstitutor>
        </TaskSection>
    );
});
